import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { formatApiError } from "../../lib/api";
import { uploadFile } from "../../lib/field";
import { today } from "./shared";
import { DateField } from "./DateField";

export const ProofDialog = ({ open, onOpenChange, title, description, url, onDone, extra = [], requireFile = true, submitLabel = "Simpan" }) => {
  const [f, setF] = useState({});
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const fields = [...extra];
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = Object.fromEntries(fields.map((x) => [x.name, f[x.name] ?? x.default ?? ""]));
      await uploadFile(url, file, payload);
      toast.success("Tersimpan");
      setF({}); setFile(null); onOpenChange(false); onDone();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="proof-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle>{description && <DialogDescription>{description}</DialogDescription>}</DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {fields.map((x) => (
            <div key={x.name} className="space-y-1">
              <Label>{x.label}{x.required && " *"}</Label>
              {x.type === "date" ? (
                <DateField value={f[x.name] ?? x.default ?? ""} onChange={(v) => setF((s) => ({ ...s, [x.name]: v }))} testid={`proof-field-${x.name}`} />
              ) : (
                <Input type={x.type || "text"} required={x.required} value={f[x.name] ?? x.default ?? ""}
                  onChange={(e) => setF((s) => ({ ...s, [x.name]: e.target.value }))} data-testid={`proof-field-${x.name}`} />
              )}
            </div>
          ))}
          <div className="space-y-1">
            <Label>Bukti (foto/PDF){requireFile && " *"}</Label>
            <Input type="file" required={requireFile} accept="image/*,application/pdf" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="proof-file" />
          </div>
          <Button disabled={busy} className="w-full bg-emerald-800 hover:bg-emerald-900" data-testid="proof-submit-btn">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{submitLabel}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const TRANSFER_FIELDS = [
  { name: "transferDate", label: "Tanggal transfer", type: "date", required: true, default: today() },
  { name: "reference", label: "No. referensi transfer" },
];
